module.exports = "/app/main/img/pic-checkin.afc7c63c.png";